import { IonButtons, IonHeader, IonPage, IonTitle, IonToolbar } from '@ionic/react';
import React, { forwardRef, ReactNode } from 'react';

import BackButton from '@components/BackButton';

interface TabLayoutProps {
  title: string;
  children: ReactNode;
}

const TabLayout = forwardRef<HTMLDivElement, TabLayoutProps>(({ title, children }, ref) => (
  <IonPage ref={ref}>
    <IonHeader className="ion-no-border">
      <IonToolbar>
        <IonButtons slot="start">
          <BackButton />
        </IonButtons>
        <IonTitle className="ion-text-wrap">{title}</IonTitle>
      </IonToolbar>
    </IonHeader>
    {children}
  </IonPage>
));

export default TabLayout;
